import { render, staticRenderFns } from "./Statistics_Partners.vue?vue&type=template&id=62377fa7&scoped=true&"
import script from "./Statistics_Partners.vue?vue&type=script&lang=js&"
export * from "./Statistics_Partners.vue?vue&type=script&lang=js&"
import style0 from "./Statistics_Partners.vue?vue&type=style&index=0&id=62377fa7&lang=scss&%2C=true&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62377fa7",
  null
  
)

export default component.exports